/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthBaseService } from '../auth-base-service';
import { AuthApiConfiguration } from '../auth-api-configuration';
import { AuthStrictHttpResponse } from '../auth-strict-http-response';

import { serviceTokenGetGet } from '../fn/service-token/service-token-get-get';
import { ServiceTokenGetGet$Params } from '../fn/service-token/service-token-get-get';
import { TokenResponseModel } from '../models/token-response-model';

@Injectable({ providedIn: 'root' })
export class AuthServiceTokenService extends AuthBaseService {
  constructor(config: AuthApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `serviceTokenGetGet()` */
  static readonly ServiceTokenGetGetPath = '/ServiceToken/Get';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `serviceTokenGetGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  serviceTokenGetGet$Response(params?: ServiceTokenGetGet$Params, context?: HttpContext): Observable<AuthStrictHttpResponse<TokenResponseModel>> {
    return serviceTokenGetGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `serviceTokenGetGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  serviceTokenGetGet(params?: ServiceTokenGetGet$Params, context?: HttpContext): Observable<TokenResponseModel> {
    return this.serviceTokenGetGet$Response(params, context).pipe(
      map((r: AuthStrictHttpResponse<TokenResponseModel>): TokenResponseModel => r.body)
    );
  }

}
